<template>
  <div>
    <h3 class="text-xl mb-6">General Information</h3>
    <div class="w-full flex flex-wrap">
      <div class="w-full md:w-1/2 pr-3">
        <div class="flex-grow mr-1 mb-6">
          <label for="first_name" class="block text-xs mb-2">First Name<span class="text-primary">*</span></label>
          <input type="text" id="first_name" v-model="order.first_name" class="input w-full bg-white text-grey-darkest" tabindex="1">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('first_name')" v-text="errorBag.get('first_name')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="company" class="block text-xs mb-2">Company Name / Estate Agency Brand<span class="text-primary">*</span></label>
          <input type="text" id="company" v-model="order.company" class="input w-full bg-white text-grey-darkest" tabindex="3">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('company')" v-text="errorBag.get('company')"></small>
        </div>
      </div>
      <div class="w-full md:w-1/2 pl-3">
        <div class="flex-grow mr-1 mb-6">
          <label for="last_name" class="block text-xs mb-2">Last Name<span class="text-primary">*</span></label>
          <input type="text" id="last_name" v-model="order.last_name" class="input w-full bg-white text-grey-darkest" tabindex="2">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('last_name')" v-text="errorBag.get('last_name')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="email_address" class="block text-xs mb-2">Email Address<span class="text-primary">*</span></label>
          <input type="text" id="email_address" v-model="order.email" class="input w-full bg-white text-grey-darkest" tabindex="5" @blur="checkOrderUserBooked(order.email)">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('email')" v-text="errorBag.get('email')"></small>
        </div>
      </div>
    </div>
    <div class="w-full mb-8">
      <div class="w-full block mb-4">
        <div class="inline-block pr-2">
          <input type="checkbox" id="exclude_current_user" class="align-middle cursor-pointer" v-model="order.exclude_current_user" :value="true" />
          <label for="exclude_current_user" class="text-sm align-middle cursor-pointer">Don't include me, I'm booking for others</label>
        </div>
      </div>
      <small class="block text-primary text-medium mt-2" v-if="errorBag.get('exclude_current_user')" v-text="errorBag.get('exclude_current_user')"></small>
    </div>
  </div>
</template>
<script>
import { v2Api } from '@/http'

export default {
  data () {
    return {
    }
  },
  props: ['event', 'ticket', 'order', 'errorBag'],
  methods: {
    checkOrderUserBooked (email) {
      if (this.order.additional_users.length > 0) {
        if (this.order.additional_users.find(obj => obj.email === email)) {
          alert('You have selected this email in additional attendees, so there is no need to include yourself again.')
          this.order.exclude_current_user = true
          return
        }
      }
      if (email) {
        v2Api
          .post(`/event-tickets/${this.ticket.ticket_id}/check-existing-user`, {
            'email': email
          })
          .then(
            response => {
              if (response.data.result && !this.order.exclude_current_user) {
                alert('A ticket was already booked for you in another order. You still can book tickets for other users but you cannot book another ticket for yourself.')
                this.order.exclude_current_user = true
              }
            }
          )
      }
    }
  },
  watch: {
    'order.exclude_current_user' () {
      if (!this.order.exclude_current_user) {
        this.checkOrderUserBooked(this.order.email)
      }
    }
  }
}
</script>
